import { createBookingsService } from "api-client";

const bookingsPath =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const bookingsService = createBookingsService(bookingsPath);
